// ============================================================
// CENTRAL CONTENT CONFIG — iinspire.my (iINSPIRE ecosystem)
// Edit this file to update social links, videos, engagements,
// books, dental content and contact details without touching
// page components.
// ============================================================

export const GROWTH_FACTOR_URL = "https://growthfactor.iinspire.my";

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "Dental", path: "/dental" },
  { label: "Consulting", path: "/consulting" },
  { label: "Creative", path: "/creative" },
  { label: "Coffee With Dr. Irma", path: "/coffee-with-dr-irma" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" },
];

export const SOCIAL_LINKS = [
  { id: "tiktok", label: "TikTok", url: "https://www.tiktok.com/@drirmaariandi" },
  { id: "instagram", label: "Instagram", url: "https://www.instagram.com/drirmaariandi" },
  { id: "linkedin", label: "LinkedIn", url: "https://www.linkedin.com/in/dr-irma-ariandi-8298001bb" },
  { id: "facebook", label: "Facebook", url: "https://www.facebook.com/share/1JURZ614h6/" },
  { id: "threads", label: "Threads", url: "https://www.threads.com/@drirmaariandi" },
  { id: "spotify", label: "Spotify", url: "https://open.spotify.com/s/OS0xy6e" },
  { id: "linktree", label: "Linktree", url: "https://linktr.ee/drirmaariandi" },
];

export const CONTACT_INFO = {
  company: "iINSPIRE",
  tagline: "Dental • Consulting • Creative",
  email: "klinikpergigianirmaariandi@gmail.com",
  phone: "011-3306 5735",
  country: "Malaysia",
};

// --- Central contact / WhatsApp routing ---
// Single iINSPIRE hotline for all verticals. Leads stay tagged by
// vertical, source page, campaign and enquiry type.
export const WHATSAPP_NUMBER = "601133065735";
export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const CLINIC = {
  name: "Klinik Pergigian Irma Ariandi",
  address:
    "1-24 & 1-25, Aras 1, Plaza Larkin, Jalan Garuda, 80350 Johor Bahru, Johor, Malaysia",
  email: "klinikpergigianirmaariandi@gmail.com",
  phoneDisplay: "011-3306 5735",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1758448093806-88b2089068ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwY29ycG9yYXRlJTIwb2ZmaWNlfGVufDB8fHx8MTc4NzQ4NzE4NXww&ixlib=rb-4.1.0&q=85",
  portrait: "/images/dr-irma.jpg",
  "engagement-mara": "/images/engagement-mara.jpg",
  "engagement-jtdc": "/images/engagement-jtdc.jpg",
  "engagement-pujb": "/images/engagement-pujb.jpg",
  "video-1": "/images/video-1.jpg",
  "video-2": "/images/video-2.jpg",
  "video-3": "/images/video-3.jpg",
  "video-4": "/images/video-4.jpg",
  coffee:
    "https://images.pexels.com/photos/8424478/pexels-photo-8424478.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  engagement1:
    "https://images.unsplash.com/photo-1758630737900-a28682c5aa69?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHw0fHxlbGVnYW50JTIwY29ycG9yYXRlJTIwb2ZmaWNlfGVufDB8fHx8MTc4NzQ4NzE4NXww&ixlib=rb-4.1.0&q=85",
  engagement2:
    "https://images.unsplash.com/photo-1686100511314-7d4a52987f2f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwY29ycG9yYXRlJTIwb2ZmaWNlfGVufDB8fHx8MTc4NzQ4NzE4NXww&ixlib=rb-4.1.0&q=85",
  "book-40": "/images/book-40.jpg",
  "book-gagal": "/images/book-gagal.jpg",
};

// --- Consulting ---
export const PATHWAYS = [
  {
    id: "myself",
    kicker: "Myself",
    title: "Personal Growth",
    description:
      "Self-awareness, direction, resilience and personal development.",
    cta: "Explore Personal Growth",
    href: "/consulting/solutions#human-talent",
    icon: "user",
  },
  {
    id: "my-business",
    kicker: "My Business",
    title: "Business Growth & Consultancy",
    description:
      "Business diagnosis, strategy, branding, marketing and growth.",
    cta: "Grow My Business",
    href: "/consulting/solutions#business-consulting",
    icon: "briefcase",
  },
  {
    id: "my-people",
    kicker: "My People",
    title: "Training, Talent & Organisation Development",
    description:
      "Team development, human capital, entrepreneurship programmes and organisational growth.",
    cta: "Develop My Team",
    href: "/consulting/solutions#human-talent",
    icon: "users",
  },
  {
    id: "my-brand",
    kicker: "My Brand",
    title: "Branding, Marketing & Advertising",
    description:
      "Brand strategy, marketing consultancy and advertising solutions across radio, digital, print, portals and billboard.",
    cta: "Amplify My Brand",
    href: "/consulting/solutions#advertising",
    icon: "megaphone",
  },
  {
    id: "my-website",
    kicker: "Digital Studio",
    title: "Websites & Digital Growth Systems",
    description:
      "IAGSB Digital Studio — strategy-led websites, landing pages and growth systems with honest, written pricing.",
    cta: "Visit Digital Studio",
    href: "/consulting/digital-studio",
    icon: "briefcase",
  },
];

export const SOLUTIONS = [
  {
    id: "human-talent",
    letter: "A",
    title: "Human & Talent Development",
    tagline: "Diagnosis-informed programmes — not generic motivational sessions.",
    services: [
      "Keynotes & Lectures",
      "Masterclasses",
      "Leadership",
      "Career Readiness",
      "Women Empowerment",
      "Human Capital Development",
      "Team Development",
      "Team Building",
      "Entrepreneurship Development",
    ],
    whoFor:
      "Organisations, institutions and teams who want people development that is practical, grounded and tied to real outcomes.",
    problem:
      "Programmes that energise for a day but change nothing — generic content with no link to what your people actually face.",
    howWeHelp:
      "We begin by understanding your people and context before designing anything. Every programme is built on a clear picture of where your team is and what will genuinely move them.",
    deliverables:
      "Keynotes, masterclasses, leadership and team programmes, career readiness and entrepreneurship development — designed around your diagnosis, delivered with practical tools.",
  },
  {
    id: "business-consulting",
    letter: "B",
    title: "Business Consulting",
    tagline: "Clarity before strategy. Strategy before spend.",
    services: [
      "Business Growth Diagnostic",
      "Business Strategy",
      "SME Growth",
      "Founder & Solopreneur Development",
      "Customer & Market Positioning",
      "Execution Priorities",
    ],
    whoFor:
      "SME owners, founders and solopreneurs who feel busy but not clearly growing.",
    problem:
      "Plateaued revenue, scattered priorities, and marketing spend without a clear diagnosis of what is actually holding the business back.",
    howWeHelp:
      "We diagnose the business first — structure, market, message and execution — then agree the few priorities that matter, and stay with you as they turn into movement.",
    deliverables:
      "Business growth diagnostic, strategy and positioning work, execution roadmaps and founder development — including the Growth Factor business pathway.",
  },
  {
    id: "branding-marketing",
    letter: "C",
    title: "Branding & Marketing Consultancy",
    tagline: "A brand is a diagnosis made visible.",
    services: [
      "Brand Positioning",
      "Rebranding",
      "Campaign Strategy",
      "Marketing Planning",
      "Message Development",
    ],
    whoFor:
      "Businesses whose brand no longer reflects who they are — or whose marketing activity lacks a clear, consistent message.",
    problem:
      "Inconsistent messaging, a dated identity, and campaigns built on instinct rather than insight.",
    howWeHelp:
      "We clarify who you are, who you serve and why it matters — then build positioning, message and campaign strategy around that clarity.",
    deliverables:
      "Brand positioning and rebranding programmes, campaign strategy, marketing plans and message frameworks.",
  },
  {
    id: "advertising",
    letter: "D",
    title: "Advertising Solutions",
    tagline: "The right channel, chosen deliberately.",
    services: ["Radio", "Digital", "Print", "Online Portals", "Billboard"],
    whoFor:
      "Organisations and brands that want their message placed with intent — not scattered across every available channel.",
    problem:
      "Advertising spend spread thin across channels, with no strategy connecting placement to audience and objective.",
    howWeHelp:
      "We advise on and coordinate advertising solutions across radio, digital, print, online portals and billboard — matching channel to audience, message and budget.",
    deliverables:
      "Channel strategy, campaign coordination and media placement advisory across radio, digital, print, portals and billboard.",
  },
];

export const GF_PATHWAYS = [
  {
    id: "personal",
    label: "Personal Growth",
    description: "Personal diagnostic + premium report.",
    accent: "emerald",
  },
  {
    id: "business",
    label: "Business Growth",
    description: "Business diagnostic + Bird Archetype + growth direction.",
    accent: "navy",
  },
  {
    id: "organisation",
    label: "Organisation / Cohort",
    description:
      "Before/After cohort diagnostic for organisations and programmes.",
    accent: "royal",
  },
];

export const METHODOLOGY = [
  { step: "Diagnose", description: "Understand the real problem." },
  { step: "Understand", description: "See the patterns, constraints and opportunities." },
  { step: "Intervene", description: "Choose the right action, programme or strategy." },
  { step: "Grow", description: "Measure progress and strengthen what works." },
];

export const IRMA_FRAMEWORK = [
  { step: "Inspire", description: "Awaken possibility." },
  { step: "Reframe", description: "See the situation differently." },
  { step: "Mobilise", description: "Turn insight into action." },
  { step: "Ascend", description: "Grow toward the next level." },
];

export const ENGAGEMENTS = [
  {
    id: "mara",
    organisation: "MARA",
    programme: "Program Pemerkasaan Wanita Dan Komuniti Johor",
    focus: "Women & Community Empowerment",
    year: "June & July 2026",
    outcome: "",
    image: "engagement-mara",
  },
  {
    id: "jtdc",
    organisation: "JTDC",
    programme: "JTDC Connect @ Kulai - Life Beyond Campus",
    focus: "",
    year: "August 2026",
    outcome: "",
    image: "engagement-jtdc",
  },
  {
    id: "pujb",
    organisation: "PUJB",
    programme: "Program Keusahawanan PUJB 2026 - Brand2Market 1 Day Coaching",
    focus: "Human Potential & Entrepreneurship",
    year: "Aug & Sept 2026",
    outcome: "",
    image: "engagement-pujb",
  },
];

export const VIDEOS = [
  {
    id: "ep-1",
    title: "Takut Itu Tanda Tumbuh",
    description: "On fear, courage and the first signs of growth.",
    thumbnail: "video-1",
    url: "https://vt.tiktok.com/ZSVuTHjmX/",
  },
  {
    id: "ep-2",
    title: "Pernah Rasa Nak Give Up?",
    description: "Dr. Irma on the moment before you quit — and what to hold on to.",
    thumbnail: "video-2",
    url: "https://vt.tiktok.com/ZSVuTCgTT/",
  },
  {
    id: "ep-3",
    title: "Kejayaan Just Around the Corner",
    description: "Hidden growth — success isn't always visible right away.",
    thumbnail: "video-3",
    url: "https://vt.tiktok.com/ZSVuTCUsA/",
  },
  {
    id: "ep-4",
    title: "Ruang Tanpa Penghakiman",
    description: "A space without judgement — stories from the journey.",
    thumbnail: "video-4",
    url: "https://vt.tiktok.com/ZSVuTWTWL/",
  },
];

export const SPEAKING_PHOTOS = [
  {
    src: "/images/engagement-mara.jpg",
    alt: "Dr. Irma speaking at MARA — Program Pemerkasaan Wanita Dan Komuniti Johor",
    tag: "MARA",
    caption: "Program Pemerkasaan Wanita Dan Komuniti • Johor • June 2026",
  },
  {
    src: "/images/mara-2.jpg",
    alt: "Dr. Irma on stage at the MARA women and community empowerment programme",
    tag: "MARA",
    caption: "Program Pemerkasaan Wanita Dan Komuniti • Johor • July 2026",
  },
  {
    src: "/images/engagement-jtdc.jpg",
    alt: "Dr. Irma speaking at JTDC Connect @ Kulai — Life Beyond Campus",
    tag: "JTDC",
    caption: "JTDC Connect • Kulai • August 2026",
  },
  {
    src: "/images/engagement-pujb.jpg",
    alt: "Brand2Market 1-day coaching session, Program Keusahawanan PUJB 2026",
    tag: "PUJB",
    caption: "Brand2Market Coaching • August 2026",
  },
  {
    src: "/images/mara-3.jpg",
    alt: "Participants at the MARA programme in Johor",
    tag: "MARA",
    caption: "Program Pemerkasaan Wanita Dan Komuniti • Johor • June 2026",
  },
  {
    src: "/images/mara-4.jpg",
    alt: "Dr. Irma with participants at the MARA programme",
    tag: "MARA",
    caption: "Program Pemerkasaan Wanita Dan Komuniti • Johor • July 2026",
  },
];

export const BOOKS = [
  {
    id: "40-a-do-over",
    title: "40. A DO OVER",
    subtitle: "",
    language: "English",
    status: "Coming Soon",
    featured: true,
    author: "Irma",
    synopsis:
      "A memoir-style reflection on life, turning forty, marriage, motherhood, self-forgiveness, faith — and the courage of beginning again.",
    excerpt: "Begin again, with quiet grace. With firmer spine and softer face.",
    coverImage: "/images/book-40.jpg",
    buyLinks: [],
  },
  {
    id: "gagal",
    title: "GAGAL",
    subtitle: "Titik Mula Bangkit Luar Biasa",
    language: "Bahasa Melayu",
    status: "Coming Soon",
    featured: false,
    author: "Irma",
    synopsis:
      "A reflective, personal-growth work exploring failure, identity, resilience, silence, rebuilding — and what it means to remain human.",
    excerpt: "",
    coverImage: "/images/book-gagal.jpg",
    buyLinks: [],
  },
];

// --- Dental: Klinik Pergigian Irma Ariandi ---
export const DENTAL_TREATMENTS = [
  {
    id: "braces",
    name: "Conventional Braces",
    description:
      "Time-tested fixed orthodontics for reliable, controlled tooth movement.",
    wa: "Hi, saya dari website dan ingin bertanya tentang Conventional Braces.\nSource: Dental Website — Braces",
  },
  {
    id: "aligners",
    name: "Clear Aligners",
    description:
      "Discreet, removable orthodontics — planned with digital precision.",
    wa: "Hi, saya dari website dan ingin bertanya tentang Clear Aligners.\nSource: Dental Website — Clear Aligners",
  },
  {
    id: "frc",
    name: "FRC",
    description:
      "Fibre-reinforced composite — a conservative way to replace a missing tooth.",
    wa: "Hi, saya ingin bertanya tentang FRC.\nSource: Dental Website — FRC",
  },
  {
    id: "zirconia",
    name: "Zirconia Crowns & Bridges",
    description:
      "Strong, aesthetic restorations for damaged or missing teeth.",
    wa: "Hi, saya ingin bertanya tentang Zirconia Crowns & Bridges.\nSource: Dental Website — Zirconia",
  },
  {
    id: "veneers",
    name: "Aesthetic Veneers & Smile Makeover",
    description:
      "Thoughtfully designed smiles — planned carefully, never over-promised.",
    wa: "Hi, saya ingin bertanya tentang Veneers / Smile Makeover.\nSource: Dental Website — Veneers",
  },
];

export const DENTAL_PROBLEMS = [
  {
    label: "I want straighter teeth.",
    wa: "Hi, saya dari website dan ingin bertanya tentang rawatan untuk gigi yang lebih lurus.\nSource: Dental Website — Straighter Teeth",
  },
  {
    label: "I want a discreet orthodontic option.",
    wa: "Hi, saya dari website dan ingin bertanya tentang Clear Aligners.\nSource: Dental Website — Clear Aligners",
  },
  {
    label: "I want to improve my smile.",
    wa: "Hi, saya ingin bertanya tentang Veneers / Smile Makeover.\nSource: Dental Website — Veneers",
  },
  {
    label: "I have a missing/broken front tooth.",
    wa: "Hi, saya ingin bertanya tentang FRC.\nSource: Dental Website — FRC",
  },
  {
    label: "I need to restore damaged teeth.",
    wa: "Hi, saya ingin bertanya tentang Zirconia Crowns & Bridges.\nSource: Dental Website — Zirconia",
  },
  {
    label: "I'm looking for braces for my teenager.",
    wa: "Hi, saya dari website dan ingin bertanya tentang braces untuk anak remaja saya.\nSource: Dental Website — Teen Braces",
  },
  {
    label: "I'm travelling from Singapore.",
    wa: "Hi, I'm enquiring from Singapore about dental treatment in Johor Bahru.\nSource: Dental Website — Singapore Patient",
  },
  {
    label: "I'm travelling from Indonesia.",
    wa: "Hi, saya dari Indonesia dan ingin bertanya tentang rawatan gigi di Johor Bahru.\nSource: Dental Website — Indonesia Patient",
  },
  {
    label: "I'm not sure which treatment I need.",
    wa: "Hi, saya dari website dan ingin mendapatkan panduan tentang rawatan yang sesuai.\nSource: Dental Website — General",
  },
];

export const DENTAL_DOCTORS = [
  { id: "dr-irma", name: "Dr. Irma", qualification: "DDS (UKM)", image: "portrait" },
  { id: "dr-ariandi", name: "Dr. Ariandi", qualification: "DDS (UKM)", image: "" },
];

export const DENTAL_PROMISE = [
  "Good dentistry.",
  "Honest advice.",
  "Transparent fees.",
  "Human care.",
];
